import { SET_COMPANY, SET_WAREHOUSE } from '../types'
import { getCompanies } from 'redux/services/clientsServices'

export const setCompany = code => ({
  type: SET_COMPANY,
  payload: code,
})

export const setWareHouse = payload => ({
  type: SET_WAREHOUSE,
  payload,
})

export const fetchCompanies = () => async () => {
  const response = await getCompanies()
  const { data, status } = response

  if (status === 200 && data?.Data) {
    return data.Data
  }

  return []
}
